import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Nosotros } from "@/components/Nosotros";
import { Servicios } from "@/components/Servicios";
import { Galeria } from "@/components/Galeria";
import { Musicos } from "@/components/Musicos";
import { Contacto } from "@/components/Contacto";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { FloatingBrochure } from "@/components/FloatingBrochure";
import { IntroSound } from "@/components/IntroSound";

const Landing = () => {
    return (
        <div className="min-h-screen bg-background text-foreground antialiased">
            <Navbar />
            <main>
                <Hero />
                <Nosotros />
                <Servicios />
                <Galeria />
                <Musicos />
                <Contacto />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <FloatingBrochure />
            <IntroSound />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
